import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectNestedErrorsExist } from 'services/error/selectors';

// Types
import { Namespace } from 'types';
import { AppState } from 'services/types';

export interface OwnProps {
    namespace: Namespace;
    children: React.ReactElement | React.ReactElement[];
    FallbackComponent?: React.ReactElement;
}

interface ConnectedProps {
    nestedErrorsExist?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class NestedErrorsExistGate extends React.PureComponent<Props> {
    render(): React.ReactElement | React.ReactElement[] | null {
        const { children, FallbackComponent, nestedErrorsExist } = this.props;
        if (!nestedErrorsExist) {
            return FallbackComponent || null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    nestedErrorsExist: makeSelectNestedErrorsExist()
});

export default connect(mapStateToProps)(NestedErrorsExistGate);
